/* Copyright Verge Technologies 2018
 * @file thankYou.js
 * @author Brenton Watt <brenton@verge.co.za>
 */

// Modules
import React from 'react';
import { Link } from 'react-router-dom';

const ThankYou = () => {
  return (
    <div>
      <div className="heading-container">
        <h1>Thank you!</h1>
        <hr />
      </div>
      <div className="complete-panel">
        <h2>
          Your request for a quote
          <br />
          has been submitted
        </h2>
        <div className="control">
          <Link to="/" className="button button-green">
            Home
          </Link>
          <Link to="/products" className="button button-green">
            Browse More
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ThankYou;



// WEBPACK FOOTER //
// ./src/components/ThankYou/thankYou.js